// extracted by mini-css-extract-plugin
module.exports = {"surveyForm":"typeform_surveyForm__yedXW","head":"typeform_head__oQolo","skipButton":"typeform_skipButton__Nk9ok"};